import DeleteIcon from "../../assets/Icons/DeleteIcon";
import LockIcon from "../../assets/Icons/LockIcon";
import { InfoContainer } from "../../pages/MyAccount/component/common";
import { Button } from "../Buttons";

const DeleteAccountForm1 = ({ confirmHandler, cancelHandler }) => {
  const Account = {
    info1: {
      title: " Things that will be deleted",
      className: "text-[#E53F50] bg-[#E53F5038]",
      list: ["Loan history", "Personal Profile Details", "Documents"],
      icon: <DeleteIcon />,
    },
    info2: {
      title: " Things that  won't be deleted",
      className: "text-[#00C08B] bg-[#00C08B33]",
      list: ["Point 1", "Point 2", "Point 3"],
      icon: <LockIcon />,
    }
  }
  return (<>
    <div className="flex flex-col items-center justify-center">
      <p className="font-Apparat font-[700] text-[16px] md:text-[20px] leading-[20px] md:leading-[24px] tracking-[-2%] text-[#424952]">
        Delete My Account
      </p>
      <p className="font-Apparat font-[500] text-[12px] md:text-[16px] leading-[17px] md:leading-[19px] tracking-[-2%] text-[#424952] text-opacity-[70%] my-[14px] text-center max-w-[90%] md:max-w-[80%]">
        Are you sure you want to delete your account? This action is permanent and cannot be undone.
      </p>
    </div>
    <div className="flex flex-col items-center mt-[16px]">
      <div className="flex flex-col md:flex-row gap-[40px] justify-center">
        <InfoContainer {...Account?.info1} />
        <InfoContainer {...Account?.info2} />
      </div>
      <div className="flex flex-col md:flex-row gap-[16px] mt-[24px] w-full">
        <div className="w-[100%] md:w-[50%]">
          <Button variant="quaternary" className="!text-[#424952] bg-[#EDEDED]
       w-full flex justify-center
        " title={"Yes delete my account"}
            onClick={confirmHandler}
          />
        </div>
        <div className="w-[100%] md:w-[50%]">
          <Button
            className=" w-full flex justify-center"
            title={"Keep My account"}
            onClick={cancelHandler}
          />
        </div>


      </div>
    </div>
  </>
  )
}
export default DeleteAccountForm1;